<template>
  <div class="main">
    <sub>
      <section>
        <h2>アップロードチュートリアル</h2>
      </section>
      <section>
        <h3>目次</h3>
        <ol>
          <li>
            <a href="#basic_info">基本情報の入力</a><br>
          </li>
          <li>
            <a href="#open_data">オープンデータの入力項目</a><br>
          </li>
          <li>
            <a href="#system">システムの入力項目</a><br>
          </li>
          <li>
            <a href="#api">APIの入力項目</a><br>
          </li>
        </ol>
      </section>
      <section>
        <h3 id="basic_info">基本情報の入力手順</h3>
        <ol>
          <li>タイトル：アップロードするオープンデータまたはシステムの名称を入力します。</li>
          <li>説明：アップロードするオープンデータまたはシステムの概要を入力します。</li>
          <li>カテゴリ：アップロードする内容に応じて「オープンデータ」、「システム」、「API」の中から一つを選択します。</li>
        </ol>
      </section>
      <section>
        <h3 id="open_data">
          オープンデータの場合の追加手順
        </h3>
        <ol>
          <li>ジャンル：アップロードするオープンデータのジャンルを選択します。</li>
          <li>ライセンス：データの利用条件に応じたライセンスを選択します。</li>
          <li>データの説明：データの構造や単位など、利用者が理解しやすいように説明を入力します。</li>
          <li>ファイルのアップロード：アップロードするJSONのファイルを選択します。</li>
        </ol>
        データの構造や単位の説明の例：
        <ul>
          <li>データの構造の説明：キー名など</li>
          <li>各キーの説明：データ型、単位（例：温度（℃）、距離（km）など）</li>
          <li>データの更新頻度：毎日、毎週、毎月など</li>
        </ul>
      </section>
      <section>
        <h3 id="system">
          システムの場合の追加手順
        </h3>
      </section>
      <section>
        <h3 id="api">
          APIの場合の追加手順
        </h3>
        <ol>
          <li>ベースURL：APIのベースとなるURLを入力します。</li>
          <li>エンドポイントの追加：APIの各エンドポイントについて、以下の情報を入力します。
            <ul>
              <li>エンドポイント名：エンドポイントの名称を入力します。</li>
              <li>メソッド：GET、POSTなど、エンドポイントで使用するHTTPメソッドを選択します。</li>
              <li>説明：エンドポイントの機能や用途について説明を入力します。</li>
            </ul>
          </li>
        </ol>
        パスパラメータを含む場合：
        <ul>
          <li>エンドポイント名にパスパラメータを含める場合は、{parameter}の形式で入力します。例：user/{userId}/details</li>
          <li>説明欄にパスパラメータの詳細を記載します。例：userIdはユーザーの一意の識別子を表します。</li>
        </ul>
      </section>
      <section>
        <router-link to="/opendataupload">
          <button>戻る</button>
        </router-link>
      </section>
    </sub>
  </div>
</template>

<style>
html {
  scroll-behavior: smooth;
}
</style>